import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';

interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li' | 'section';
  // Marks this row as a custom-cursor hover target (see Cursor.tsx).
  hoverable?: boolean;
}

export const Reveal: React.FC<RevealProps> = ({
  children,
  className = '',
  delay = 0,
  as = 'div',
  hoverable = false,
}) => {
  const { elementRef, isVisible } = useScrollAnimation<HTMLDivElement>({
    threshold: 0.15,
    rootMargin: '0px 0px -8% 0px',
  });

  const Tag = as as React.ElementType;

  return (
    <Tag
      ref={elementRef}
      className={`reveal ${isVisible ? 'is-visible' : ''} ${className}`}
      style={delay ? { transitionDelay: `${delay}ms` } : undefined}
      data-cursor-hover={hoverable ? '' : undefined}
    >
      {children}
    </Tag>
  );
};
